<template>
  <app-collapse
    v-if="notes"
    heading="Notes"
    :is-open="true"
  >
    <div class="space-y-2">
      <app-card variant="muted">
        <p class="text-sm text-gray-600">{{ displayNotes }}</p>
        <button
          v-if="isTruncated"
          class="btn btn-secondary w-full mt-3"
          @click="showMore = !showMore"
        >
          {{ showMore ? 'Show less' : 'Show more' }}
        </button>
      </app-card>
      <div class="flex gap-2">
        <app-icon
          name="info-circle"
          variant="solid"
          size="sm"
        />
        <span class="text-xs font-medium">
          Do not include personal or payment details (e.g., credit card numbers, passport info) in notes.
        </span>
      </div>
    </div>
  </app-collapse>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { truncate } from '@/utils/string';

const props = defineProps({
  notes: {
    type: String,
    required: true,
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
});

const showMore = ref(false);

const isTruncated = computed(() => props.notes.length > 255);

const displayNotes = computed(() => {
  if (showMore.value) {
    return props.notes;
  }
  return truncate(props.notes, 255);
});

watch(
  () => props.notes,
  () => {
    showMore.value = false;
  }
);
</script>
